<template>
  <div class="home">
    <router-view :session="session"></router-view>
    <Navigation :session="session"/>
  </div>
</template>

<script>
import Navigation from "../components/Navigation";

export default {
    name: 'Home',
    components: {
      Navigation
    },
    props: ['session']
  }
</script>

<style>
  body {
    padding-top: 72px;
  }
</style>
